import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesPet({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 5.83c2.17 0 4.06 2.056 5.87 5.986a2.673 2.673 0 01-2.946 3.74l-2.25-.445a3.478 3.478 0 00-1.348 0l-2.25.444a2.673 2.673 0 01-2.946-3.739C3.94 7.886 5.83 5.831 8 5.831zm0 1.933c-1.159 0-2.595 1.56-4.114 4.86a.741.741 0 00.816 1.037l2.25-.445a5.41 5.41 0 012.097 0l2.25.445a.74.74 0 00.815-1.036C10.595 9.324 9.16 7.764 8 7.764zM1.778 5.444c.982 0 1.778.995 1.778 2.223 0 1.227-.796 2.222-1.778 2.222S0 8.894 0 7.667c0-1.228.796-2.223 1.778-2.223zm12.444 0c.982 0 1.778.995 1.778 2.223 0 1.227-.796 2.222-1.778 2.222s-1.778-.995-1.778-2.222c0-1.228.796-2.223 1.778-2.223zM5.333 1c.982 0 1.778.995 1.778 2.222 0 1.228-.796 2.222-1.778 2.222S3.556 4.45 3.556 3.222C3.556 1.995 4.35 1 5.333 1zm5.334 0c.982 0 1.777.995 1.777 2.222 0 1.228-.795 2.222-1.777 2.222-.982 0-1.778-.994-1.778-2.222C8.889 1.995 9.685 1 10.667 1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgRulesPet.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesPet.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRulesPet svgRef={ref} {...props} />);
export default ForwardRef;
